<template>
  <div class="site-shell">
    <TopNavbar2 />
    <main class="page-content">
      <router-view />
    </main>
    <contactUs v-if="$route.name !== 'contact'" />
  </div>
</template>

<script>
import TopNavbar2 from '@/components/TopNavbar2.vue';
import contactUs from '@/components/main/portal/contactUs.vue';

export default {
  components: { TopNavbar2, contactUs },
};
</script>

<style scoped>
.site-shell {
  min-height: 100vh;
  background: #ffffff;
}

.page-content {
  min-height: 60vh;
}
</style>
